export enum SchedulePeriod {
    CURRENT_PERIOD = 'CURRENT_PERIOD',
    NEXT_PERIOD = 'NEXT_PERIOD',
}
